import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";

const SharedLabels = Resources.PortfolioDetail.SharedLabels;

type Props = {
	recurringValue: string | null;
	totalInvested: string;
	totalValue: string;
};

export const ToolSummaryRows: FC<Props> = ({
	recurringValue,
	totalInvested,
	totalValue,
}) => {
	const { t } = useResource();

	return (
		<>
			{recurringValue !== null && (
				<DetailRow
					label={t(SharedLabels.recurringPayment)}
					value={recurringValue}
				/>
			)}
			<DetailRow label={t(SharedLabels.investedAll)} value={totalInvested} />
			<DetailRow label={t(SharedLabels.currentValue)} value={totalValue} />
		</>
	);
};
